export default __webpack_public_path__ + "static/media/AbrahamLincolnQuestion.e1a4db93.png";